import IPretendente from '../interfaces/IPretendente';
import { caminhoInformacoesDoPretendente } from '../telas/DadosConjuge/consultaNomeConjuge';
import { apiDaInscricao } from './axios';

const obterInformacoesNoServicoDeConsultaDeCpf = async (cpf: string, dataDeNascimento: string) => {
  const resposta = await apiDaInscricao().get(caminhoInformacoesDoPretendente(cpf, dataDeNascimento));
  return resposta.data;
};

const validarJuncao = async (idInscricao: number, cpf: string)  => {
  const resposta = await apiDaInscricao().get(`/conjuge/${idInscricao}/validarJuncao/${cpf}`);
  return resposta.data;
};

const verificarSePermiteCadastro = async (idInscricao: number, cpf: string)  => {
  const resposta = await apiDaInscricao().get(`/conjuge/${idInscricao}/verificarSePermiteCadastro?cpf=${cpf}`);
  return resposta.data; 
};

const obterPorCpf = async (cpf: string) => {
  const resposta = await apiDaInscricao().get(`/pretendentes/${cpf}/obter`);
  return resposta.data;
};

const juntarInscricoes = async (idInscricaoOrigem: number, idInscricaoDestino: number, pretendente: IPretendente) => {
  await apiDaInscricao().post('/JuncaoDeInscricao/juntar/', {idInscricaoOrigem, idInscricaoDestino, conjuge : pretendente});
};

export { obterInformacoesNoServicoDeConsultaDeCpf, validarJuncao, verificarSePermiteCadastro, obterPorCpf, juntarInscricoes };